
import React from 'react';

export default function ServicesSection() {
  const services = [
    {
      id: 1,
      icon: 'ri-brain-line',
      title: 'AI碳排放智能分析',
      description: '运用人工智能和大数据技术，实现碳排放的智能识别、精准分析和预测优化',
      features: ['机器学习算法', 'AI预测模型', '智能决策支持', '自动化报告'],
      techLevel: '前沿AI技术',
      image: 'https://readdy.ai/api/search-image?query=Artificial%20intelligence%20carbon%20emission%20analysis%20system%20with%20neural%20networks%2C%20machine%20learning%20algorithms%20visualizing%20carbon%20data%2C%20AI-powered%20environmental%20monitoring%20dashboards%2C%20futuristic%20data%20processing%20centers%20with%20holographic%20displays%20showing%20emission%20patterns%20and%20predictions&width=600&height=400&seq=ai-carbon-service-001&orientation=landscape'
    },
    {
      id: 2,
      icon: 'ri-sensor-line',
      title: 'IoT智能监测网络',
      description: '部署先进的物联网传感器网络，实现碳排放的实时监测和数据采集',
      features: ['智能传感器', '实时数据采集', '无线传输网络', '边缘计算处理'],
      techLevel: '物联网技术',
      image: 'https://readdy.ai/api/search-image?query=IoT%20sensor%20network%20for%20carbon%20monitoring%20with%20smart%20environmental%20sensors%2C%20wireless%20data%20transmission%20towers%2C%20edge%20computing%20devices%2C%20real-time%20monitoring%20systems%20in%20industrial%20facilities%2C%20connected%20environmental%20monitoring%20infrastructure&width=600&height=400&seq=iot-carbon-service-002&orientation=landscape'
    },
    {
      id: 3,
      icon: 'ri-links-line',
      title: '区块链碳资产管理',
      description: '基于区块链技术构建可信碳资产管理平台，确保数据透明性和交易安全性',
      features: ['分布式账本', '智能合约', '数字化碳资产', '去中心化交易'],
      techLevel: '区块链技术',
      image: 'https://readdy.ai/api/search-image?query=Blockchain%20carbon%20asset%20management%20platform%20with%20cryptocurrency%20networks%2C%20digital%20carbon%20tokens%2C%20smart%20contracts%20visualization%2C%20decentralized%20ledger%20systems%2C%20secure%20trading%20interfaces%20with%20blockchain%20nodes%20and%20cryptographic%20elements&width=600&height=400&seq=blockchain-carbon-service-003&orientation=landscape'
    },
    {
      id: 4,
      icon: 'ri-cpu-line',
      title: '数字孪生碳模拟',
      description: '构建企业碳排放数字孪生模型，实现碳足迹的精确模拟和优化方案测试',
      features: ['3D建模仿真', '实时数据同步', '场景模拟测试', '优化方案验证'],
      techLevel: '数字孪生技术',
      image: 'https://readdy.ai/api/search-image?query=Digital%20twin%20carbon%20simulation%20with%203D%20environmental%20modeling%2C%20virtual%20factory%20simulations%2C%20real-time%20data%20synchronization%20displays%2C%20carbon%20footprint%20visualization%20in%20virtual%20environments%2C%20advanced%20simulation%20software%20interfaces&width=600&height=400&seq=digital-twin-service-004&orientation=landscape'
    },
    {
      id: 5,
      icon: 'ri-cloud-line',
      title: '云端碳管理平台',
      description: '基于云计算的一站式碳管理SaaS平台，提供弹性计算和智能服务',
      features: ['云原生架构', '弹性扩容', 'API接口开放', '多租户支持'],
      techLevel: '云计算技术',
      image: 'https://readdy.ai/api/search-image?query=Cloud-based%20carbon%20management%20platform%20with%20server%20farms%2C%20cloud%20computing%20infrastructure%2C%20SaaS%20dashboard%20interfaces%2C%20scalable%20computing%20resources%2C%20modern%20data%20centers%20with%20environmental%20monitoring%20systems&width=600&height=400&seq=cloud-carbon-service-005&orientation=landscape'
    },
    {
      id: 6,
      icon: 'ri-robot-line',
      title: '智能减排机器人',
      description: '部署AI驱动的智能减排执行系统，自动化实施碳减排措施和能效优化',
      features: ['自动化控制', '智能优化算法', '自适应调节', '预测性维护'],
      techLevel: '机器人技术',
      image: 'https://readdy.ai/api/search-image?query=Intelligent%20emission%20reduction%20robots%20and%20automated%20systems%20in%20industrial%20environments%2C%20AI-powered%20control%20systems%2C%20robotic%20arms%20managing%20environmental%20equipment%2C%20smart%20automation%20for%20carbon%20reduction%2C%20futuristic%20industrial%20robots&width=600&height=400&seq=robot-carbon-service-006&orientation=landscape'
    },
    {
      id: 7,
      icon: 'ri-quantum-line',
      title: '量子计算碳优化',
      description: '利用下一代量子计算技术，解决复杂的碳减排优化问题和供应链建模',
      features: ['量子算法', '复杂问题求解', '供应链优化', '多变量建模'],
      techLevel: '量子计算技术',
      image: 'https://readdy.ai/api/search-image?query=Quantum%20computing%20for%20carbon%20optimization%20with%20quantum%20processors%2C%20advanced%20quantum%20computers%2C%20complex%20mathematical%20modeling%20displays%2C%20futuristic%20quantum%20technology%20laboratories%2C%20sophisticated%20quantum%20algorithms%20visualization&width=600&height=400&seq=quantum-carbon-service-007&orientation=landscape'
    }
  ];

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="services" className="py-20 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-gradient-to-r from-emerald-100 to-cyan-100 text-emerald-700 rounded-full text-sm font-medium mb-4 border border-emerald-200">
            <i className="ri-rocket-line mr-2"></i>
            前沿科技服务
          </div>
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            下一代
            <span className="bg-gradient-to-r from-emerald-600 to-cyan-600 bg-clip-text text-transparent">智能环保</span>
            解决方案
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            融合AI、IoT、区块链等前沿技术，构建智能化碳管理生态系统，引领环保科技创新
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={service.id} className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden group border border-gray-100 hover:border-emerald-200">
              {/* Service Image */}
              <div className="h-48 overflow-hidden relative">
                <img 
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute top-4 right-4 bg-black/70 text-white px-3 py-1 rounded-full text-xs backdrop-blur-sm">
                  {service.techLevel}
                </div>
              </div>
              
              {/* Service Content */}
              <div className="p-6">
                <div className="flex items-center mb-4">
                  <div className={`w-12 h-12 bg-gradient-to-br ${
                    index % 3 === 0 ? 'from-emerald-100 to-green-100' :
                    index % 3 === 1 ? 'from-blue-100 to-cyan-100' :
                    'from-purple-100 to-indigo-100'
                  } rounded-lg flex items-center justify-center mr-4 group-hover:scale-110 transition-transform duration-300`}>
                    <i className={`${service.icon} ${
                      index % 3 === 0 ? 'text-emerald-600' :
                      index % 3 === 1 ? 'text-blue-600' :
                      'text-purple-600'
                    } text-xl`}></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900">{service.title}</h3>
                </div>
                
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {service.description}
                </p>
                
                {/* Tech Features */}
                <div className="grid grid-cols-2 gap-2 mb-6">
                  {service.features.map((feature, featureIndex) => (
                    <div key={featureIndex} className={`flex items-center text-sm ${
                      index % 3 === 0 ? 'text-emerald-600' :
                      index % 3 === 1 ? 'text-blue-600' :
                      'text-purple-600'
                    }`}>
                      <i className="ri-cpu-line mr-2"></i>
                      {feature}
                    </div>
                  ))}
                </div>
                
                {/* Learn More Button */}
                <div className="mt-6">
                  <button 
                    onClick={scrollToContact}
                    className={`w-full ${
                      index % 3 === 0 ? 'bg-gradient-to-r from-emerald-50 to-green-50 hover:from-emerald-100 hover:to-green-100 text-emerald-700' :
                      index % 3 === 1 ? 'bg-gradient-to-r from-blue-50 to-cyan-50 hover:from-blue-100 hover:to-cyan-100 text-blue-700' :
                      'bg-gradient-to-r from-purple-50 to-indigo-50 hover:from-purple-100 hover:to-indigo-100 text-purple-700'
                    } font-medium py-3 px-4 rounded-lg transition-all duration-300 cursor-pointer whitespace-nowrap border ${
                      index % 3 === 0 ? 'border-emerald-200' :
                      index % 3 === 1 ? 'border-blue-200' :
                      'border-purple-200'
                    }`}
                  >
                    <i className="ri-arrow-right-line mr-2"></i>
                    探索技术详情
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Technology Showcase */}
        <div className="mt-20 bg-white rounded-3xl p-8 lg:p-12 shadow-xl border border-gray-100">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-gray-900 mb-4">
              核心技术优势
            </h3>
            <p className="text-lg text-gray-600">领先的环保科技创新能力</p>
          </div>
          
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center group">
              <div className="w-16 h-16 bg-gradient-to-br from-emerald-100 to-green-100 rounded-2xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300">
                <i className="ri-brain-line text-emerald-600 text-2xl"></i>
              </div>
              <div className="text-2xl font-bold text-gray-900 mb-2">AI算法</div>
              <div className="text-gray-600 text-sm">18+项专利算法</div>
            </div>
            <div className="text-center group">
              <div className="w-16 h-16 bg-gradient-to-br from-blue-100 to-cyan-100 rounded-2xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300">
                <i className="ri-database-line text-blue-600 text-2xl"></i>
              </div>
              <div className="text-2xl font-bold text-gray-900 mb-2">大数据</div>
              <div className="text-gray-600 text-sm">PB级数据处理</div>
            </div>
            <div className="text-center group">
              <div className="w-16 h-16 bg-gradient-to-br from-purple-100 to-indigo-100 rounded-2xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300">
                <i className="ri-links-line text-purple-600 text-2xl"></i>
              </div>
              <div className="text-2xl font-bold text-gray-900 mb-2">区块链</div>
              <div className="text-gray-600 text-sm">分布式可信网络</div>
            </div>
            <div className="text-center group">
              <div className="w-16 h-16 bg-gradient-to-br from-orange-100 to-red-100 rounded-2xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300">
                <i className="ri-cloud-line text-orange-600 text-2xl"></i>
              </div>
              <div className="text-2xl font-bold text-gray-900 mb-2">云原生</div>
              <div className="text-gray-600 text-sm">弹性扩容架构</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
